import Vue from 'vue'
import Axios from 'axios'

Axios.defaults.headers.post['Content-Type'] = 'application/json'
const axiosInstance = Axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? 'https://biobigdata.nju.edu.cn' : '/',
    withCredentials: true,
})

// 通过拦截器处理csrf问题，这里的正则和匹配下标可能需要根据实际情况小改动
axiosInstance.interceptors.request.use((config) => {
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    const regex = /.*csrftoken=([^;.]*).*$/
    config.headers['X-CSRFToken'] = document.cookie.match(regex) === null ? null : document.cookie.match(regex)[1]
    return config
})

axiosInstance.interceptors.response.use(
    response => {
        return response
    },
    error => {
        return Promise.reject(error)
    }
)

Vue.prototype.axios = axiosInstance

export default axiosInstance